var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},_vm._l((_vm.data),function(item){return _c('div',{key:item.PhienDauGia.Id,staticClass:"col-lg-4 col-md-4",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.$router.push('/product/detail/' + item.PhienDauGia.Id)}}},[_c('auction-item',{attrs:{"data":item}})],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-480db858","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/AuctionList.vue
// module id = null
// module chunks = 